import Vue from 'vue'
import axios from 'axios'



Vue.use({
    install(Vue) {
       
         Vue.prototype.$http = axios.create({
            baseURL: 'https://mamd-707d2.firebaseio.com'
         })

         Vue.prototype.$recaptchaReturn = axios.create({
            baseURL: 'https://www.google.com/recaptcha/api', 

           
           
         })

    }
})
